module.exports = __webpack_public_path__ + "img/close_omni.e80ac3ba.svg";